"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.some.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.map.js");
var _utils = require("../utils");
var _raf = require("../utils/raf");
var _event = require("../utils/event");
var _touch = require("../mixins/touch");
var _scroll = require("../utils/scroll");
var _info = _interopRequireDefault(require("../info"));
var _swipe = _interopRequireDefault(require("../swipe"));
var _swipeItem = _interopRequireDefault(require("../swipe-item"));
var _use = (0, _utils.use)('tabs'),
  sfc = _use[0],
  bem = _use[1];
var tabBem = (0, _utils.use)('tab')[1];
var TYPES = ['line', 'card', 'check', 'check-large'];
var _default = sfc({
  mixins: [_touch.TouchMixin],
  model: {
    prop: 'active'
  },
  props: {
    color: String,
    left: Boolean,
    center: Boolean,
    sticky: Boolean,
    animated: Boolean,
    offsetTop: Number,
    activeOffset: Number,
    swipeable: Boolean,
    disableNestSwipe: Boolean,
    background: String,
    forceActive: Boolean,
    stickyBackground: String,
    titleActiveColor: String,
    titleInactiveColor: String,
    nativeSwipe: Boolean,
    touchable: {
      type: Boolean,
      default: true
    },
    swipeDistance: {
      type: Number,
      default: 50
    },
    ellipsis: {
      type: Boolean,
      default: true
    },
    lazyRender: {
      type: Boolean,
      default: true
    },
    // 把 indicator 的默认宽度写在 css 中是为了考虑自定义主题时设置宽度
    lineWidth: {
      type: [Number, String],
      default: null
    },
    lineHeight: {
      type: Number,
      default: null
    },
    active: {
      type: [Number, String],
      default: 0
    },
    type: {
      type: String,
      default: 'line',
      validator: function validator(val) {
        return TYPES.includes(val);
      }
    },
    disableInitAnimation: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 0.3
    },
    swipeThreshold: {
      type: Number,
      default: 4
    },
    wire: {
      type: Boolean,
      default: false
    },
    multiScrollerTab: {
      type: Boolean,
      default: false
    },
    recoverOffsetWhenChange: {
      type: Boolean,
      default: false
    },
    showIndicator: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      tabs: [],
      position: '',
      curActive: null,
      initActive: null,
      scrollTop: {},
      indicatorStyle: {},
      events: {
        resize: false,
        sticky: false,
        swipeable: false
      },
      isTransition: false
    };
  },
  computed: {
    isSticky: function isSticky() {
      return ['top', 'bottom'].includes(this.position);
    },
    scrollable: function scrollable() {
      return this.tabs.length > this.swipeThreshold || !this.ellipsis || this.left || this.type.includes('check');
    },
    wrapStyle: function wrapStyle() {
      switch (this.position) {
        case 'top':
          return {
            position: 'fixed',
            top: this.offsetTop + 'px'
          };
        case 'bottom':
          return {
            top: 'auto',
            bottom: 0
          };
        default:
          return null;
      }
    },
    fixBottomStyle: function fixBottomStyle() {
      switch (this.position) {
        case 'top':
          return {
            position: 'fixed',
            top: this.offsetTop + this.$refs.wrap.getBoundingClientRect().height + 'px'
          };
        case 'bottom':
          return {
            top: 'auto',
            bottom: 0
          };
        default:
          return null;
      }
    },
    fixBottomPlaceholderStyle: function fixBottomPlaceholderStyle() {
      var _this$$refs$fixBotto;
      var fixBottomHeight = ((_this$$refs$fixBotto = this.$refs['fix-bottom']) === null || _this$$refs$fixBotto === void 0 ? void 0 : _this$$refs$fixBotto.offsetHeight) || 0;
      switch (this.position) {
        case 'top':
        case 'bottom':
          return fixBottomHeight ? {
            height: fixBottomHeight + 'px',
            display: 'block'
          } : {
            display: 'none'
          };
        default:
          return {
            display: 'none'
          };
      }
    },
    navStyle: function navStyle() {
      return {
        borderColor: this.color,
        background: this.isSticky ? this.stickyBackground : this.background
      };
    },
    trackStyle: function trackStyle() {
      if (this.animated) {
        return {
          transform: "translate3d(" + -1 * this.curActive * 100 + "%, 0, 0)",
          transitionDuration: this.disableInitAnimation && !this.inited ? 0 : this.duration + "s"
        };
      }
    }
  },
  watch: {
    active: function active() {
      var index = this.transformToIndex(this.active);
      if (index !== this.curActive) {
        this.correctActive(index);
      }
    },
    tabs: function tabs() {
      var _this = this;
      var index = this.transformToIndex(this.curActive || this.active);
      this.correctActive(index);
      this.setIndicatorStyle();
      this.$nextTick(function () {
        _this.scrollIntoView();
      });
    },
    curActive: function curActive() {
      var _this2 = this;
      if (this.curActive !== null && this.initActive === null) {
        this.initActive = this.curActive;
      }
      this.scrollIntoView();
      this.setIndicatorStyle();

      // scroll to correct position
      if (this.isSticky && !this.multiScrollerTab) {
        (0, _scroll.setScrollTop)(window, (0, _scroll.getElementTop)(this.$el) - this.offsetTop);
      }
      this.$nextTick(function () {
        if (_this2.scrollEl && _this2.recoverOffsetWhenChange && !_this2.multiScrollerTab) {
          (0, _scroll.setScrollTop)(_this2.scrollEl, _this2.scrollTop[_this2.curActive] || 0);
        }
      });
    },
    color: function color() {
      this.setIndicatorStyle();
    },
    sticky: function sticky() {
      this.handlers(true);
    },
    swipeable: function swipeable() {
      this.handlers(true);
    }
  },
  mounted: function mounted() {
    this.onShow();
  },
  activated: function activated() {
    this.onShow();
    this.setIndicatorStyle();
  },
  deactivated: function deactivated() {
    this.handlers(false);
  },
  beforeDestroy: function beforeDestroy() {
    this.handlers(false);
  },
  methods: {
    getBottomOffsetTop: function getBottomOffsetTop() {
      return this.offsetTop + this.$refs.wrap.getBoundingClientRect().height;
    },
    transformToIndex: function transformToIndex(active) {
      if (typeof active === 'number') {
        return active;
      } else {
        var index = this.tabs.findIndex(function (item) {
          return item.id === active;
        });
        return index === -1 ? +active : index;
      }
    },
    onShow: function onShow() {
      var _this3 = this;
      this.$nextTick(function () {
        // const { nav } = this.$refs;
        // console.log('onShow', window.screen.width, nav.offsetWidth)
        _this3.inited = true;
        _this3.handlers(true);
        _this3.scrollIntoView(true);
      });
    },
    // whether to bind sticky listener
    handlers: function handlers(bind) {
      var events = this.events;
      var sticky = this.sticky && bind;
      var swipeable = this.swipeable && bind;

      // listen to window resize event
      if (events.resize !== bind) {
        events.resize = bind;
        (bind ? _event.on : _event.off)(window, 'resize', this.setIndicatorStyle, true);
      }

      // listen to scroll event
      if (events.sticky !== sticky) {
        events.sticky = sticky;
        this.scrollEl = this.scrollEl || (0, _scroll.getScrollEventTarget)(this.$el);
        (sticky ? _event.on : _event.off)(this.scrollEl, 'scroll', this.onScroll, true);
        this.onScroll();
      }

      // listen to touch event
      if (events.swipeable !== swipeable) {
        events.swipeable = swipeable;
        var content = this.$refs.content;
        var action = swipeable ? _event.on : _event.off;
        action(content, 'touchstart', this.touchStart);
        action(content, 'touchmove', this.touchMove);
        action(content, 'touchend', this.onTouchEnd);
        action(content, 'touchcancel', this.onTouchEnd);
        if (this.multiScrollerTab) {
          action(content, 'transitionend', this.onTransitionEnd);
        }
      }
    },
    onTransitionEnd: function onTransitionEnd(e) {
      this.isTransition = false;
    },
    // watch swipe touch end
    onTouchEnd: function onTouchEnd(e) {
      // 如果设置了阻止滑动切换
      if (!this.touchable) {
        return false;
      }
      // 防止tabs嵌套使用时，内部tabs滑动切换会触发外部tabs的切换
      if (this.disableNestSwipe && this.$refs.content.querySelectorAll('.z-tab__pane-wrapper')[this.curActive] && this.$refs.content.querySelectorAll('.z-tab__pane-wrapper')[this.curActive].querySelector('.z-tabs') && this.$refs.content.querySelectorAll('.z-tab__pane-wrapper')[this.curActive].querySelector('.z-tabs').contains(e.target)) {
        return false;
      }
      var direction = this.direction,
        deltaX = this.deltaX,
        curActive = this.curActive;
      var minSwipeDistance = 50;

      /* istanbul ignore else */
      if (direction === 'horizontal' && this.offsetX >= minSwipeDistance) {
        /* istanbul ignore else */
        if (deltaX > 0 && curActive !== 0) {
          this.setCurActive(curActive - 1);
        } else if (deltaX < 0 && curActive !== this.tabs.length - 1) {
          this.setCurActive(curActive + 1);
        }
      }
    },
    // adjust tab position
    onScroll: function onScroll() {
      var scrollTop = (0, _scroll.getScrollTop)(window) + this.offsetTop;
      var elTopToPageTop = (0, _scroll.getElementTop)(this.$el);
      if (!this.$refs.wrap) {
        return;
      }
      var elBottomToPageTop = elTopToPageTop + this.$el.offsetHeight - this.$refs.wrap.offsetHeight;
      if (this.multiScrollerTab && (!this.isTransition || this.direction === 'vertical' || this.isTransition && this.position === '') || !this.multiScrollerTab) {
        if (scrollTop > elBottomToPageTop) {
          this.position = 'bottom';
        } else if (scrollTop > elTopToPageTop) {
          this.position = 'top';
        } else {
          this.position = '';
        }
      }
      var scrollParams = {
        scrollTop: scrollTop,
        isFixed: this.isSticky
      };
      this.scrollTop[this.curActive] = scrollTop;
      this.$emit('scroll', scrollParams);
    },
    // update nav bar style
    setIndicatorStyle: function setIndicatorStyle() {
      var _this4 = this;
      var inited = this.inited;

      // 缓存indicator宽度，在tabs变化，触发setIndicatorStyle时会有一些未知bug
      if (this.$refs.indicator) {
        this.indicatorWidth = this.$refs.indicator.offsetWidth;
      }
      this.$nextTick(function () {
        var _this4$$refs = _this4.$refs,
          tabs = _this4$$refs.tabs,
          indicator = _this4$$refs.indicator;
        if (!tabs || !tabs[_this4.curActive]) {
          _this4.indicatorStyle = {
            opacity: 0
          }; // for forceActive
          return;
        }
        var tab = tabs[_this4.curActive];
        var indicatorStyle = {};
        if (_this4.type === 'line') {
          var lineWidth = _this4.lineWidth,
            lineHeight = _this4.lineHeight,
            color = _this4.color;
          var width = lineWidth === 'auto' ? tab.offsetWidth / 2 : (0, _utils.isDef)(lineWidth) ? lineWidth : undefined;
          var indicatorWidth = (0, _utils.isDef)(width) ? width : _this4.indicatorWidth || indicator.offsetWidth;
          var insideOffset = (tab.offsetWidth - indicatorWidth) / 2;
          var left = tab.offsetLeft + insideOffset;
          indicatorStyle.width = (0, _utils.isDef)(width) && width + "px";
          indicatorStyle.backgroundColor = color;
          indicatorStyle.transform = "translateX(" + left + "px)";
          if ((0, _utils.isDef)(lineHeight)) {
            var height = lineHeight + "px";
            indicatorStyle.height = height;
            indicatorStyle.borderRadius = height;
          }
        } else if (_this4.type.includes('check')) {
          var _left = tab.offsetLeft + tab.offsetWidth;
          indicatorStyle.transform = "translateX(" + _left + "px)";
        }
        if (inited) {
          indicatorStyle.transitionDuration = _this4.duration + "s";
        }
        _this4.indicatorStyle = indicatorStyle;
      });
    },
    // correct the value of active
    correctActive: function correctActive(index) {
      var exist = this.tabs.some(function (tab) {
        return tab.index === index;
      });
      var defaultIndex = (this.tabs[0] || {}).index || 0;
      index = this.forceActive ? index : exist ? index : defaultIndex;
      this.setCurActive(index);
    },
    setCurActive: function setCurActive(index) {
      index = this.findAvailableTab(index, index < this.curActive);
      var _ref = this.tabs[index] || {},
        title = _ref.title,
        id = _ref.id;
      if ((0, _utils.isDef)(index) && index !== this.curActive) {
        this.$emit('input', id || index);
        if (this.curActive !== null) {
          this.$emit('change', id || index, title);
          if (this.nativeSwipe) {
            var _this$$refs, _this$$refs$swipeTabs;
            (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : (_this$$refs$swipeTabs = _this$$refs.swipeTabs) === null || _this$$refs$swipeTabs === void 0 ? void 0 : _this$$refs$swipeTabs.swipeTo(index);
          }
        }
        this.curActive = index;
      }
    },
    findAvailableTab: function findAvailableTab(active, reverse) {
      var diff = reverse ? -1 : 1;
      var index = active;
      while (index >= 0 && index < this.tabs.length) {
        if (!this.tabs[index].disabled) {
          return index;
        }
        index += diff;
      }
    },
    // emit event when clicked
    onClick: function onClick(index) {
      var _this$tabs$index = this.tabs[index],
        title = _this$tabs$index.title,
        id = _this$tabs$index.id,
        disabled = _this$tabs$index.disabled;
      if (disabled) {
        this.$emit('disabled', id || index, title);
      } else {
        this.setCurActive(index);
        this.$emit('click', id || index, title);
      }
    },
    // scroll active tab into view
    scrollIntoView: function scrollIntoView(immediate) {
      var tabs = this.$refs.tabs;
      if (!this.scrollable || !tabs || !tabs[this.curActive]) {
        return;
      }
      var nav = this.$refs.nav;
      var scrollLeft = nav.scrollLeft,
        navWidth = nav.offsetWidth;
      var _tabs$this$curActive = tabs[this.curActive],
        offsetLeft = _tabs$this$curActive.offsetLeft,
        tabWidth = _tabs$this$curActive.offsetWidth;
      var activeOffset = offsetLeft - (this.activeOffset || (navWidth - tabWidth) / 2);
      this.scrollTo(nav, scrollLeft, activeOffset, immediate);
    },
    // animate the scrollLeft of nav
    scrollTo: function scrollTo(el, from, to, immediate) {
      if (immediate) {
        el.scrollLeft += to - from;
        return;
      }
      var count = 0;
      var frames = Math.round(this.duration * 1000 / 16);
      var animate = function animate() {
        el.scrollLeft += (to - from) / frames;
        /* istanbul ignore next */
        if (++count < frames) {
          (0, _raf.raf)(animate);
        }
      };
      animate();
    },
    handleRightTabClick: function handleRightTabClick() {
      this.$emit('click-fix-right-tab');
      this.curActive = -1;
    },
    // render title slot of child tab
    renderTitle: function renderTitle(el, index) {
      var _this5 = this;
      this.$nextTick(function () {
        var title = _this5.$refs.title[index];
        title.parentNode.replaceChild(el, title);
      });
    },
    getTabStyle: function getTabStyle(tab, index) {
      var style = {};
      var color = this.color;
      var isActive = index === this.curActive;
      var isCard = this.type === 'card';

      // theme color
      if (color) {
        if (!tab.disabled && isCard && !isActive) {
          style.color = color;
        }
        if (!tab.disabled && isCard && isActive) {
          style.backgroundColor = color;
        }
        if (isCard) {
          style.borderColor = color;
        }
      }
      var titleColor = isActive ? this.titleActiveColor : this.titleInactiveColor;
      if (titleColor) {
        style.color = titleColor;
      }
      if (this.scrollable && this.ellipsis && !tab.info && this.swipeThreshold > 0) {
        style.flexBasis = 88 / this.swipeThreshold + '%';
      }
      return style;
    },
    onSwipeMove: function onSwipeMove(swipeData) {
      this.isTransition = true;
      var active = swipeData.active,
        pace = swipeData.pace;
      var curActive = (active + pace + this.tabs.length) % this.tabs.length;
      if (curActive !== this.curActive) {
        this.curActive = curActive;
        var _ref2 = this.tabs[curActive] || {},
          title = _ref2.title,
          id = _ref2.id;
        this.$emit('input', id || curActive);
        this.$emit('change', id || curActive, title);
      }
    }
  },
  render: function render(h) {
    var _this6 = this,
      _this$slots;
    var type = this.type,
      left = this.left,
      center = this.center,
      ellipsis = this.ellipsis,
      animated = this.animated,
      nativeSwipe = this.nativeSwipe,
      scrollable = this.scrollable,
      wire = this.wire,
      multiScrollerTab = this.multiScrollerTab;
    var Nav = this.tabs.map(function (tab, index) {
      return h("div", {
        "ref": "tabs",
        "refInFor": true,
        "class": [tabBem({
          active: index === _this6.curActive,
          disabled: tab.disabled,
          complete: !ellipsis || tab.info,
          wire: index !== 0 && wire
        }), tab.tabClass],
        "style": _this6.getTabStyle(tab, index),
        "on": {
          "click": function click() {
            return _this6.onClick(index);
          }
        }
      }, [h("span", {
        "class": tabBem('title', {
          block: ellipsis && !tab.info
        })
      }, [h("span", {
        "ref": "title",
        "refInFor": true
      }, [tab.title]), h(_info.default, {
        "attrs": {
          "info": tab.info,
          "type": "text"
        }
      })])]);
    });
    return h("div", {
      "class": bem([type])
    }, [h("div", {
      "ref": "wrap",
      "style": this.wrapStyle,
      "class": [bem('wrap', {
        scrollable: scrollable
      })]
    }, [h("div", {
      "ref": "nav",
      "style": this.navStyle,
      "class": bem('nav', [type, left && 'left', center && 'center'])
    }, [this.slots('nav-left'), Nav, this.slots('nav-right'), this.showIndicator ? h("div", {
      "ref": "indicator",
      "class": bem(type),
      "style": this.indicatorStyle
    }) : '']), this.slots('fix-right') && type === 'line' && h("div", {
      "class": bem('fix-right'),
      "on": {
        "click": function click() {
          return _this6.$emit('click-fix-right');
        }
      }
    }, [this.slots('fix-right')]), this.slots('fix-right-tab') && type === 'line' && h("div", {
      "class": [bem('fix-right-tab'), this.curActive === -1 && bem('fix-right-active')],
      "on": {
        "click": function click() {
          return _this6.handleRightTabClick();
        }
      }
    }, [this.slots('fix-right-tab'), this.curActive === -1 && h("div", {
      "class": bem('fix-right-line')
    })])]), this.slots('fix-bottom') && h("div", {
      "class": bem('fix-bottom'),
      "ref": "fix-bottom",
      "style": this.fixBottomStyle,
      "on": {
        "click": function click() {
          return _this6.$emit('click-fix-right');
        }
      }
    }, [this.slots('fix-bottom')]), this.slots('fix-bottom') && h("div", {
      "class": bem('fix-bottom'),
      "style": this.fixBottomPlaceholderStyle
    }), h("div", {
      "ref": "content",
      "class": bem('content', {
        animated: animated
      })
    }, [nativeSwipe ? h(_swipe.default, {
      "ref": "swipeTabs",
      "attrs": {
        "swipe-distance": this.swipeDistance,
        "loop": false,
        "multiScrollerTab": multiScrollerTab,
        "nativeSwipe": nativeSwipe,
        "showIndicators": false,
        "initialSwipe": this.initActive,
        "touchable": this.touchable
      },
      "on": {
        "change": function change(index) {
          _this6.curActive = index;
        },
        "move": this.onSwipeMove
      }
    }, [(_this$slots = this.slots()) === null || _this$slots === void 0 ? void 0 : _this$slots.map(function (slot) {
      return h(_swipeItem.default, [slot]);
    })]) : animated ? h("div", {
      "class": bem('track'),
      "style": this.trackStyle
    }, [this.slots()]) : this.slots()])]);
  }
});
exports.default = _default;